let isMobile;

/**
 * heroObserverCallback
 * @description This function sets the entries parameter for the new IntersectionObserver objects
 * created when the hero is in view in intersectObserverInit().
 */
const heroObserverCallback = (entries) => {
    for (const entry of entries) {
        if (entry.intersectionRatio > 0.25) {
            // CTA Target is in view
            document.body.classList.remove('show-cta-toast');
            if (!isMobile.matches) {
                document.body.classList.remove('show-top-nav');
            }
        } else {
            // CTA Target is not in view.
            document.body.classList.add('show-cta-toast');
            if (!isMobile.matches) {
                document.body.classList.add('show-top-nav');
            }
        }
    }
};

/**
 * logoObserverCallback
 * @description This function sets the entries parameter for the new IntersectionObserver objects
 * created when the logo is in view in intersectObserverInit().
 */
const logoObserverCallback = (entries) => {
    if (isMobile.matches) {
        for (const entry of entries) {
            if (entry.intersectionRatio > 0.1) {
                // Logo is in view
                document.body.classList.remove('show-top-nav');
            } else {
                // Logo is not in view.
                document.body.classList.add('show-top-nav');
            }
        }
    }
};

/**
 * footerObserverCallback
 * @description This function sets the entries parameter for the new IntersectionObserver objects
 * created when the footer is in view in intersectObserverInit().
 */
const footerObserverCallback = (entries) => {
    for (const entry of entries) {
        if (entry.intersectionRatio > 0.1) {
            // Footer Module is in view
            document.body.classList.add('hide-cta-toast');
        } else {
            // Footer Module is not in view.
            document.body.classList.remove('hide-cta-toast');
        }
    }
};

/**
 * intersectObserverInit
 * @description This observer watches Logo, CTAs, CTA Toast Module and Footer Module
 */
const intersectObserverInit = () => {

    const options = {
        threshold: [0.1, 0.25, 0.5, 0.75, 1]
    };
    /*
        MOBILE - Show top nav early because it does not have primary cta in it
            - TOP Nav should be visible when LOGO is off screen
            - TOP Nav should be hidden when LOGO is visible

            - CTA Toast should be visible when CTA is off screen
            - CTA Toast should be hidden when CTA is visible

        DESKTOP - Show top nav late as possible because it does have primary cta in it
            - TOP Nav should be visible when hero CTAs are off screen
            - TOP Nav should be hidden when hero CTAs are off screen

        MOBILE/DESKTOP
            - CTA Toast should be hidden when footer is visible
            - CTA Toast should be visible when footer is hidden
    */

    // Modules
    const ctaToastModule = document.getElementById('cta-toast');
    const footerModule = document.getElementById('footer');

    // Targets
    const logoTarget = document.getElementById('logo');
    const heroTarget = document.getElementById('hero');

    // MOBILE - Show/Hide CTA Toast when heroTarget is out of view
    // DESKTOP - Show/Hide TOP Nav when heroTarget is out of view
    if (heroTarget) {
        const heroTargetObserver = new IntersectionObserver(heroObserverCallback, options);
        heroTargetObserver.observe(heroTarget);
    } else {
        document.body.classList.add('show-top-nav');
    }

    // MOBILE - Show/Hide Top Nav when LOGO Target is out of view
    if (logoTarget) {
        const logoTargetObserver = new IntersectionObserver(logoObserverCallback, options);
        logoTargetObserver.observe(logoTarget);
    } else {
        document.body.classList.add('show-top-nav');
    }

    // Show/Hide CTA Toast when footer is in view
    if (footerModule && ctaToastModule) {
        const footerObserver = new IntersectionObserver(footerObserverCallback, options);
        footerObserver.observe(footerModule);
    }
};

/**
 * onScrollInit
 * @description A simple intersect observer scroll watcher for navigation menus
 */
const onScrollInit = () => {
    isMobile = window.matchMedia('(max-width: 768px)');

    isMobile.addListener(intersectObserverInit);
    intersectObserverInit();
};


/**
 * lazyLoadInit
 * @description Init image lazyLoad on scroll
 */
const lazyLoadInit = (LazyLoad) => {
    return new LazyLoad({
        threshold: 400
    });
};


export {
    heroObserverCallback,
    footerObserverCallback,
    lazyLoadInit,
    onScrollInit
};
